import React from 'react'

import Card from '@/components/card/card'
import Link from '@/components/link/link'
import { generateUrl } from '@/internal/utils/generate-url'
import { getModelMessages } from '@/utils/get-model-messages'

type Props = {
  title: Queries.SectionFeaturedContentsFragment['title']
  filter: Queries.SectionFeaturedContentsFragment['filter']
  nodes: readonly (Card | null)[]
}

const FeaturedContentsCards: React.FC<Props> = (props) => {
  const { title, filter, nodes } = props
  const modelMessages = getModelMessages(filter?.__typename)
  return (
    <div className="container">
      <div className="row mt-4">
        <div className="col">
          <h2>{title}</h2>
        </div>
      </div>
      {filter && (
        <div className="row link-read-more">
          <div className="col">
            <Link to={generateUrl(filter?.__typename, filter.slug)}>
              {modelMessages.buttonAll}
            </Link>
          </div>
        </div>
      )}
      <div className="row items mt-2">
        {nodes.map((item) => {
          if (!item) {
            return null
          }
          return (
            <div
              key={item.externalName}
              className="col-lg-4 col-md-6 mb-5 mt-lg-0"
            >
              <Card item={{ ...item, card: item.card }} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FeaturedContentsCards
